import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { LANDING_LINK } from '../../../constants/UrlConstants';
import { resolveArguments } from '../../../helpers/utils';
import { CommonPagePromo } from '../common/CommonPagePromo';
import { LightNavBar } from '../common/fromAuth/LightNavBar/LightNavBar';
import { PromoInfoPage } from '../common/PromoInfoPage/PromoInfoPage';
import LogoPurple from '../header/LogoPurple';

const NotFoundInfo = (props) => {
    const getErrorText = resolveArguments(props.errorText, props.billId);

    return (
        <CommonPagePromo>
            <LightNavBar align="left">
                <LogoPurple />
            </LightNavBar>
            <PromoInfoPage
                animatedIconFail
                headerText={getErrorText}
                primaryButtonCaption={props.homePage}
                primaryButtonType="link"
                primaryButtonLink={LANDING_LINK}
            />
        </CommonPagePromo>
    );
};
const mapStateToProps = (state) => {
    return {
        errorText: state.extra?.strapiApi?.errorText,
        homePage: state.extra?.strapiApi?.homePage,
        billId: state.extra?.strapiApi?.billId,
    };
};
NotFoundInfo.propTypes = {
    errorText: PropTypes.string.isRequired,
    homePage: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(NotFoundInfo);
